"use client";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <main className="isolate app-bg min-h-screen flex items-center justify-center p-6">
      <div className="glass-strong glass-noise" style={{ borderRadius: 16, padding: 24, maxWidth: 560, width: '100%', textAlign: 'center' }}>
        <img src="/images/logo_transparent.png" alt="Teravia" style={{ width: 56, height: 'auto', margin: '0 auto 8px' }} />
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: '#0f172a' }}>Something went wrong</h1>
        <p style={{ margin: '8px 0 0', color: '#475569' }}>{error?.message || 'Please try again.'}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginTop: 14 }}>
          <button onClick={reset} className="yglass yglass-pill yglass-noise" style={{ padding: '10px 14px', fontWeight: 700 }}>Try again</button>
          <a href="/" className="glass-btn" style={{ padding: '10px 14px', borderRadius: 12, fontWeight: 700 }}>Go home</a>
        </div>
      </div>
    </main>
  );
}

